














import { Component, Prop, Vue } from "vue-property-decorator";
import Button from "@/components/Button.vue";

@Component({
  components: {
    appButton: Button
  }
})
export default class FormCard extends Vue {
  @Prop({ required: true }) readonly id!: string;
  @Prop({ required: true }) readonly name!: string;
  @Prop({ required: true }) readonly startDate!: string;
  @Prop({ required: true }) readonly endDate!: string;
  @Prop({ type: Boolean, required: true }) readonly answered!: boolean;

  get formattedDate(): string {
    const options = {
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    };
    return `${new Date(this.startDate).toLocaleDateString(
      "pt-BR",
      options
    )} - ${new Date(this.endDate).toLocaleDateString("pt-BR", options)}`;
  }

  get buttonText(): string {
    return this.answered ? "Respondido" : "Responder";
  }
}
